import { render, staticRenderFns } from "./DashboardVentilation.vue?vue&type=template&id=2dc7c358&scoped=true&"
import script from "./DashboardVentilation.vue?vue&type=script&lang=js&"
export * from "./DashboardVentilation.vue?vue&type=script&lang=js&"
import style0 from "./DashboardVentilation.vue?vue&type=style&index=0&id=2dc7c358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7c358",
  null
  
)

export default component.exports